import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import OrderReview from '../../features/order-review/OrderReview';
import OrderTotalContainer from '../../features/order-review/OrderTotalContainer';
import PosCartContainer from '../../features/order-review/PosCartContainer';
import { selectCheckEventItems } from '../../selectors/order';
import { orderActions } from '../../reducers/orderSlice';
import { selectFeatureFlagPosCart } from '../../redux/features/config/config.selector';
import Colors from '../../utils/color';
import { OrderActions } from '../OrderReview/OrderActions';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    position: 'relative',
    border: `${theme.spacing(0.125)} solid ${Colors.alto}`,
    minWidth: '300px',
    maxWidth: '360px',
  },
  subContainer: {
    position: 'relative',
    flex: 1,
    maxHeight: 'calc(100vh - 164px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '10px',
  },
}));

// Convert check event items to OrderItem format with recursive options handling
const convertCheckEventToOrderItems = (checkEventItems: any[]) => {
  const convertOptions = (options: any[]): any[] => {
    return (
      options?.map((option: any) => ({
        name: option.name,
        pos_id: option.pos_id?.toString() || option.id?.toString() || '',
        quantity: option.quantity || 1,
        price: option.price || '0.00',
        options: convertOptions(option.options || []),
      })) || []
    );
  };

  return checkEventItems.map((item) => ({
    name: item.name,
    pos_id: item.pos_id?.toString() || item.id?.toString() || '',
    quantity: item.quantity || 1,
    price: item.price || '0.00',
    options: convertOptions(item.options || []),
  }));
};

export default function RightBar() {
  const classes = useStyles();
  const checkEventItems = useAppSelector(selectCheckEventItems);
  const isPosCartEnabled = useAppSelector(selectFeatureFlagPosCart);

  // Memoize the orderItems conversion to prevent unnecessary re-renders
  const orderItems = React.useMemo(() => {
    return convertCheckEventToOrderItems(checkEventItems);
  }, [checkEventItems]);

  return (
    <div id="rightBar" className={classes.container}>
      <div id="cartContainer" className={classes.subContainer}>
        <OrderReview />
      </div>
      {isPosCartEnabled && <PosCartContainer items={orderItems} />}
      <OrderTotalContainer />
      <OrderActions />
    </div>
  );
}
